<!--等待弹窗-->
<template>
	<transition name="nomal-fade">
		<div class="container" v-show="show">
			<div class="box">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<p>loading...</p>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				show: false
			}
		},
		created() {},
		mounted() {
			
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			open(time) {
				this.show = true
				setTimeout(() => {
					this.show = false
				}, time)
			},
			close() {
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.container{
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(0,0,0,0.2);
	}
	
	.box{
		width:300px;
		height:125px;
	}

	.box p{
		text-align: center;
		width:100%;
		float:left;
		margin:0;
		padding:0;
	}

	.box div{
		width:30px;
		height:70px;
		margin:15px;
		float: left;
		background-color: hotpink;
		border-radius:10px;
	}

	.box div:nth-child(1){
		background-color: lightcoral;
		animation: loading 0.5s ease 0s infinite alternate;
	}
	.box div:nth-child(2){
		background-color: darkorange;
		animation: loading 0.5s ease 0.1s infinite alternate;
	}
	.box div:nth-child(3){
		background-color: lightcoral;
		animation: loading 0.5s ease 0.2s infinite alternate;
	}
	.box div:nth-child(4){
		background-color: gold;
		animation: loading 0.5s ease 0.3s infinite alternate;
	}
	.box div:nth-child(5){
		background-color: burlywood;
		animation: loading 0.5s ease 0.4s infinite alternate;
	}

	@keyframes loading{
		from{
			/*缩放y轴*/
			transform:scaleY(1)
		}

		to{
			transform: scaleY(0.5);
		}

	}
</style>
